import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

/**
 * Parameters for the VizPortal `listPlanOwners` Web Client method. These map to the `@PayloadParameter` names
 * on WebClientContentMobilityAppService.listPlanOwners in the monolith. It is offset-paged (`startIndex` /
 * `pageSize`, at most 100) and matched server-side.
 */
export interface IGetContentRelayPlanOwnersParams {
  /** Case-insensitive substring of the owner's display name or user name. */
  matchText?: string;
  pageSize?: number;
  startIndex?: number;
}

/** A user who owns Content Relay plans on the site. */
export interface IContentRelayPlanOwner {
  /** Site-scoped user id; the value of the plan list's owner filter. */
  userId: number;
  /** Display name; empty when the user has no system user. */
  name: string;
  /** Plans this user owns on the site. */
  planCount: number;
}

export interface IGetContentRelayPlanOwnersResult extends IResult {
  /** The owners on this page, ordered by name. */
  owners?: IContentRelayPlanOwner[];
  /** Owners matching `matchText` across all pages. */
  totalCount?: number;
}

export class GetContentRelayPlanOwnersRequest
  extends Request<IGetContentRelayPlanOwnersParams, IGetContentRelayPlanOwnersResult> {
  constructor(params: IGetContentRelayPlanOwnersParams) {
    super('listPlanOwners', params);
  }
}
